import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import update from 'immutability-helper';
import DropdownList from '../common/DropdownList';
import ConsultantInterest from '../ConsultantInterest';
import './RepProjectApplicationActions.scss';
import { analyticsTrack } from '../../analyticsUtils';

const activeApplications = (applications) => (
  applications.filter((application) => !application.rejected && !application.waitlisted)
);

const rejectedApplications = (applications) => (
  applications.filter((application) => application.rejected)
);

const waitlistedApplications = (applications) => (
  applications.filter((application) => application.waitlisted)
);

const dedupApplications = (interests, proposals) => {
  const userIdsProposals = proposals.map((proposal) => proposal.consultant_id);
  return interests.filter((interest) => !userIdsProposals.includes(interest.user_id));
};

const renderProposalAction = (proposal) => {
  if (proposal.rehireable && proposal.rep_rehire_url) {
    return (
      <Row className="row mb-0">
        <Col className="mb-0" xs={6}>
          <a
            href={proposal.rep_rehire_url}
            className="btn btn-secondary full-width edit-btn"
            onClick={() => {
              analyticsTrack('Consultant hired again', { location: 'Project Show Page', consultant: proposal.consultant.name });
            }}
          >
            Hire Again
          </a>
        </Col>
        <Col className="mb-0" xs={6}>
          <a href={proposal.review_proposal_url} className="btn btn-primary full-width review-btn">
            Review
          </a>
        </Col>
      </Row>
    );
  }

  if (proposal.editable) {
    return (
      <Row className="row mb-0">
        <Col className="mb-0" xs={6}>
          <a href={proposal.edit_url} className="btn btn-secondary full-width edit-btn">
            Edit
          </a>
        </Col>
        <Col className="mb-0" xs={6}>
          <a href={proposal.review_proposal_url} className="btn btn-primary full-width review-btn">
            Review
          </a>
        </Col>
      </Row>
    );
  }
  return (
    <a href={proposal.review_proposal_url} className="btn btn-primary full-width review-btn">
      Review
    </a>
  );
};

const renderLogistics = (daysAgo, fromOpportunity) => (
  <div className=" mb-3 ">
    {fromOpportunity
      && (
      <span className="badge badge-fallback-tertiary mr-5 normal-font pull-right">
        OpenOpps
      </span>
      )}
    <p>{daysAgo}</p>
  </div>
);

const renderProposalDetails = (proposal) => (
  <div className="mb-3">
    <p className="demibold">{proposal.status}</p>
    <h3 className="fs-hide normal-weight">
      <a href={proposal.consultant_url}>{proposal.consultant_name}</a>
      <a href={proposal.clorify_url} target="_blank" rel="noreferrer"> (view Clorify)</a>
    </h3>
  </div>
);

class RepProjectApplicationActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consultantInterests: dedupApplications(
        activeApplications(props.consultantInterests),
        props.proposals,
      ),
      proposals: activeApplications(props.proposals),
      rejectedConsultantInterests: rejectedApplications(props.consultantInterests),
      waitlistedConsultantInterests: waitlistedApplications(props.consultantInterests),
      rejectedProposals: rejectedApplications(props.proposals),
      updated: false,
    };

    this.handleRejectInterest = this.handleRejectInterest.bind(this);
    this.handleWaitlistInterest = this.handleWaitlistInterest.bind(this);
    this.createdProposal = this.createdProposal.bind(this);
  }

  handleRejectInterest(interest) {
    const { consultantInterests, rejectedConsultantInterests } = this.state;
    const interestIndex = consultantInterests.findIndex((i) => i.id === interest.id);
    const newConsultantInterests = update(consultantInterests, { $splice: [[interestIndex, 1]] });
    const newRejectedInterests = update(rejectedConsultantInterests, { $push: [interest] });
    this.setState({
      consultantInterests: newConsultantInterests,
      rejectedConsultantInterests: newRejectedInterests,
    });
  }

  handleWaitlistInterest(interest) {
    const { consultantInterests, waitlistedConsultantInterests } = this.state;
    const interestIndex = consultantInterests.findIndex((i) => i.id === interest.id);
    const newConsultantInterests = update(consultantInterests, { $splice: [[interestIndex, 1]] });
    const newInterest = { ...interest };
    newInterest.waitlisted = true;
    const newWaitlistedInterests = update(waitlistedConsultantInterests, { $push: [newInterest] });
    this.setState({
      consultantInterests: newConsultantInterests,
      waitlistedConsultantInterests: newWaitlistedInterests,
    });
  }

  createdProposal(data) {
    this.setState({
      consultantInterests: dedupApplications(
        activeApplications(data.interests),
        data.proposals,
      ),
      proposals: activeApplications(data.proposals),
    });
  }

  render() {
    const {
      createProposalPath,
      csrfToken,
      rep,
      opportunitiesUrl,
      projectUrl,
    } = this.props;
    const {
      consultantInterests,
      proposals,
      rejectedConsultantInterests,
      waitlistedConsultantInterests,
      rejectedProposals,
    } = this.state;
    return (
      <div className="rep-project-proposal-view style-guide">
        {consultantInterests.length > 0
          && (
          <DropdownList
            title={`${consultantInterests.length} resume${consultantInterests.length > 1 ? 's' : ''}`}
            dropdownClass="count-header"
          >
            <div className="consultant-interest-list">
              {consultantInterests.map((interest) => (
                <ConsultantInterest
                  key={interest.id}
                  interest={interest}
                  createProposalPath={createProposalPath}
                  csrfToken={csrfToken}
                  rep={rep}
                  opportunitiesUrl={opportunitiesUrl}
                  projectUrl={projectUrl}
                  createdProposal={this.createdProposal}
                  rejectedCallback={this.handleRejectInterest}
                  waitlistedCallback={this.handleWaitlistInterest}
                  clorifyUrl={interest.consultant_clorify_url}
                  project={interest.project}
                  resume={interest.resume}
                />
              ))}
            </div>
          </DropdownList>
          )}
        {waitlistedConsultantInterests.length > 0
          && (
          <DropdownList
            title={`${waitlistedConsultantInterests.length} waitlist`}
            dropdownClass="count-header"
          >
            <div className="wait-list">
              <div className="consultant-interest-list">
                {waitlistedConsultantInterests.map((interest) => (
                  <ConsultantInterest
                    key={interest.id}
                    interest={interest}
                    createProposalPath={createProposalPath}
                    csrfToken={csrfToken}
                    rep={rep}
                    opportunitiesUrl={opportunitiesUrl}
                    projectUrl={projectUrl}
                    createdProposal={this.createdProposal}
                    rejectedCallback={this.handleRejectInterest}
                    waitlistedCallback={this.handleWaitlistInterest}
                    clorifyUrl={interest.consultant_clorify_url}
                    project={interest.project}
                  />
                ))}
              </div>
            </div>
          </DropdownList>
          )}
        <DropdownList
          title={`${proposals.length} proposal${proposals.length !== 1 ? 's' : ''}`}
          dropdownClass="count-header"
        >
          <div className="proposal-list">
            {proposals.map((proposal) => (
              <div className="proposal">
                {renderLogistics(proposal.days_ago, proposal.from_opportunity)}
                {renderProposalDetails(proposal)}
                {renderProposalAction(proposal)}
              </div>
            ))}
          </div>
        </DropdownList>
        <DropdownList
          title={`${rejectedConsultantInterests.length + rejectedProposals.length} rejected`}
          dropdownClass="count-header"
        >
          <div className="rejected-list">
            <div className="proposal-list">
              {rejectedProposals.map((proposal) => (
                <div className="proposal">
                  {renderLogistics(proposal.days_ago, proposal.from_opportunity)}
                  {renderProposalDetails(proposal)}
                  <a
                    href={proposal.review_proposal_url}
                    className="btn btn-primary full-width proposal-rejected"
                  >
                    View Proposal
                  </a>
                </div>
              ))}
            </div>
            <div className="consultant-interest-list">
              {rejectedConsultantInterests.map((interest) => (
                <ConsultantInterest
                  key={interest.id}
                  interest={interest}
                  createProposalPath={createProposalPath}
                  csrfToken={csrfToken}
                  rep={rep}
                  opportunitiesUrl={opportunitiesUrl}
                  projectUrl={projectUrl}
                  rejectedCallback={this.handleRejectInterest}
                  waitlistedCallback={this.handleWaitlistInterest}
                  clorifyUrl={interest.consultant_clorify_url}
                  project={interest.project}
                />
              ))}
            </div>
          </div>
        </DropdownList>
      </div>
    );
  }
}

RepProjectApplicationActions.propTypes = {
  consultantInterests: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  proposals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  csrfToken: PropTypes.string.isRequired,
  rep: PropTypes.string.isRequired,
  opportunitiesUrl: PropTypes.string.isRequired,
  projectUrl: PropTypes.string.isRequired,
  createProposalPath: PropTypes.string.isRequired,
};

export default RepProjectApplicationActions;
